import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseAPIService } from '../../base-api.service';
import { HttpParams } from '@angular/common/http';
import { MOI } from '../enums/moi.enum';

export interface Message {
  menuObjectId?: number;
  messageId?: number;
  languageId?: number;
  text?: string;
  toolTip?: string;
  debugMessage?: string;
}

@Injectable()
export class BiggerPictureMessagesService {

  i18FileName = 'en';

  constructor(private translate: TranslateService, private http: BaseAPIService) {
    this.translate.use(this.i18FileName);
  }

  loadMessages(moi) {
    if (!isNaN(moi)) {
      const path = `/messages/moi/${moi}`;
      return this.http.get(`api/sys${path}`, new HttpParams());
    }
  }

  async getMessages(menuObjectId: number) {
    if (this.translate.translations[this.i18FileName] && this.translate.translations[this.i18FileName][menuObjectId]) {
      return this.translate.translations[this.i18FileName][menuObjectId];
    } else {
      const data = await this.loadMessages(String(menuObjectId)).toPromise();
      if (data) {
        this.translate.setTranslation(
          this.i18FileName,
          {[menuObjectId]: this.showMessageIds ? this.appendMessageIds(menuObjectId, data) : data},
          true
        );
        // this.translate.translations[this.i18FileName][menuObjectId] = data;
      }
      return data;
    }
  }

  /**
   * Debug flag, same convention as ecom-client: any `?showMessages=` in the URL turns it on.
   */
  private get showMessageIds(): boolean {
    return location.search.indexOf('showMessages=') > -1;
  }

  /**
   * Appends the DB coordinates of every message to its own text, so a label seen on screen
   * can be traced back to its Message row. menuObjectId is part of the badge because
   * messageId is only unique within a menu object.
   * Runs on the fetch path only, so a cached menu object can never be annotated twice.
   */
  private appendMessageIds(menuObjectId: number, data: any): any {
    Object.keys(data || {}).forEach(key => {
      const msg: Message = data[key];
      if (!msg || typeof msg !== 'object') {
        return;
      }
      const suffix = ` (${menuObjectId}.${msg.messageId != null ? msg.messageId : key})`;
      if (typeof msg.text === 'string' && msg.text) {
        msg.text += suffix;
      }
      if (typeof msg.toolTip === 'string' && msg.toolTip) {
        msg.toolTip += suffix;
      }
    });
    return data;
  }

  reset() {
    this.translate.translations[this.i18FileName] = [];
  }

  tranKey(moi: MOI, msgId: number | string, type = 'text'): string {
    return `${moi}.${msgId}.${type}`;
  }
}
